
import {
    SET_USER_INFORMATION
} from '../constant/actionTypes';

export const setUser = user => ({
    type: SET_USER_INFORMATION,
    payload: user
});
